import { inject as p, ref as i, defineComponent as v, provide as w, computed as j, onMounted as G, watchEffect as I, getCurrentInstance as S, watch as $, onUnmounted as b, h as M, Teleport as U, reactive as A } from "vue";
import { usePortalRoot as B } from "./index351.js";
import { dom as D } from "./index339.js";
import { getOwnerDocument as C } from "./index343.js";
import { render as E } from "./index345.js";
function H(e) {
  let t = C(e);
  if (!t) {
    if (e === null) return null;
    throw new Error(`[Headless UI]: Cannot find ownerDocument for contextElement: ${e}`);
  }
  let o = t.getElementById("headlessui-portal-root");
  if (o) return o;
  let r = t.createElement("div");
  return r.setAttribute("id", "headlessui-portal-root"), t.body.appendChild(r);
}
const d = /* @__PURE__ */ new WeakMap();
function W(e) {
  var t;
  return (t = d.get(e)) != null ? t : 0;
}
function y(e, t) {
  let o = t(W(e));
  return o <= 0 ? d.delete(e) : d.set(e, o), o;
}
let F = v({ name: "Portal", props: { as: { type: [Object, String], default: "div" } }, setup(e, { slots: t, attrs: o }) {
  let r = i(null), s = j(() => C(r)), n = B(), a = p(x, null), l = i(n === !0 || a == null ? H(r.value) : a.resolveTarget());
  l.value && y(l.value, (u) => u + 1);
  let m = i(!1);
  G(() => {
    m.value = !0;
  }), I(() => {
    n || a != null && (l.value = a.resolveTarget());
  });
  let c = p(f, null), g = !1, O = S();
  return $(r, () => {
    if (g || !c) return;
    let u = D(r);
    u && (b(c.register(u), O), g = !0);
  }), b(() => {
    var u, P;
    let h = (u = s.value) == null ? void 0 : u.getElementById("headlessui-portal-root");
    !h || l.value !== h || y(l.value, (T) => T - 1) || l.value.children.length > 0 || (P = l.value.parentElement) == null || P.removeChild(l.value);
  }), () => {
    if (!m.value || l.value === null) return null;
    let u = { ref: r, "data-headlessui-portal": "" };
    return M(U, { to: l.value }, E({ ourProps: u, theirProps: e, slot: {}, attrs: o, slots: t, name: "Portal" }));
  };
} }), f = Symbol("PortalParentContext");
function J() {
  let e = p(f, null), t = i([]);
  function o(n) {
    return t.value.push(n), e && e.register(n), () => r(n);
  }
  function r(n) {
    let a = t.value.indexOf(n);
    a !== -1 && t.value.splice(a, 1), e && e.unregister(n);
  }
  let s = { register: o, unregister: r, portals: t };
  return [t, v({ name: "PortalWrapper", setup(n, { slots: a }) {
    return w(f, s), () => {
      var l;
      return (l = a.default) == null ? void 0 : l.call(a);
    };
  } })];
}
let x = Symbol("PortalGroupContext"), K = v({ name: "PortalGroup", props: { as: { type: [Object, String], default: "template" }, target: { type: Object, default: null } }, setup(e, { attrs: t, slots: o }) {
  let r = A({ resolveTarget() {
    return e.target;
  } });
  return w(x, r), () => {
    let { target: s, ...n } = e;
    return E({ theirProps: n, ourProps: {}, slot: {}, attrs: t, slots: o, name: "PortalGroup" });
  };
} });
export {
  F as Portal,
  K as PortalGroup,
  J as useNestedPortals
};
